import { useCallback } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import { useProfileContext } from '../../contexts/ProfileContext'
import {
  CompletionMode,
  type CompletionRedirectState,
} from '../../types/account/accountSetup'
import { hasCompletePaymentProfile } from '../../utils/profile/profile'

type PaymentProfileOptions = {
  returnTo?: string
  returnState?: unknown
  cancelState?: unknown
}

export const useRequirePaymentProfile = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { profile } = useProfileContext()

  const requirePaymentProfile = useCallback(
    (options: PaymentProfileOptions = {}) => {
      if (hasCompletePaymentProfile(profile)) {
        return true
      }

      const redirectState: CompletionRedirectState = {
        mode: CompletionMode.PAYMENT,
        returnTo: options.returnTo ?? location.pathname,
        returnState: options.returnState,
        cancelState: options.cancelState,
      }

      navigate('/account/setup', { state: redirectState })
      return false
    },
    [location.pathname, navigate, profile]
  )

  return { requirePaymentProfile }
}
